export function isCreateMemberResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const m = value.member;
    return Boolean(m &&
        typeof m.id === 'string' &&
        /^\d{6,20}$/.test(m.nationalId) &&
        typeof m.givenNames === 'string' &&
        typeof m.familyNames === 'string' &&
        (m.email === null || typeof m.email === 'string') &&
        (m.primaryPhone === null || typeof m.primaryPhone === 'string') &&
        (m.secondaryPhone === null || typeof m.secondaryPhone === 'string') &&
        m.status === 'active' &&
        m.version === 1 &&
        !Number.isNaN(Date.parse(m.createdAt)) &&
        !Number.isNaN(Date.parse(m.updatedAt)));
}
